@if (form) {
  <div [formGroup]="form" class="modalForm">
    <div class="flex flex-column gap-2 mb-3">
      <label for="label" class="font-semibold w-full"
        >{{ "gate_administration.customer_form.label" | translate }}*</label
      >
      <input pInputText id="label" formControlName="label" autocomplete="off" />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label for="email" class="font-semibold w-full">{{
        "gate_administration.customer_form.email" | translate
      }}</label>
      <input pInputText id="email" formControlName="email" autocomplete="off" />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label for="phone" class="font-semibold w-full">{{
        "gate_administration.customer_form.phone" | translate
      }}</label>
      <input pInputText id="phone" formControlName="phone" autocomplete="off" />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label for="mobilePhone" class="font-semibold w-full">{{
        "gate_administration.customer_form.mobilePhone" | translate
      }}</label>
      <input pInputText id="mobilePhone" formControlName="mobilePhone" autocomplete="off" />
    </div>
    <ng-container formGroupName="address">
      <div class="flex flex-column gap-2 mb-3">
        <label for="street" class="font-semibold w-full">{{ "common.address.street" | translate }}</label>
        <input pInputText id="street" formControlName="street" autocomplete="off" />
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="number" class="font-semibold w-full">{{ "common.address.number" | translate }}</label>
        <input pInputText id="number" formControlName="number" autocomplete="off" />
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="zipCode" class="font-semibold w-full">{{ "common.address.zipCode" | translate }}</label>
        <input pInputText id="zipCode" formControlName="zipCode" autocomplete="off" />
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="city" class="font-semibold w-full">{{ "common.address.city" | translate }}</label>
        <input pInputText id="city" formControlName="city" autocomplete="off" />
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="country" class="font-semibold w-full">{{ "common.address.country" | translate }}</label>
        <p-select id="country" formControlName="country" [options]="countries" class="w-full">
          <ng-template let-country #selectedItem>
            {{ country.label | translate }}
          </ng-template>
          <ng-template let-country #item>
            {{ country.label | translate }}
          </ng-template>
        </p-select>
      </div>
    </ng-container>
    <div style="grid-column: 1 / 3" class="flex flex-column gap-2 mb-3">
      <label for="notes" class="font-semibold w-full">{{
        "gate_administration.customer_form.notes" | translate
      }}</label>
      <textarea rows="5" cols="30" pInputTextarea formControlName="notes" [autoResize]="true"> </textarea>
    </div>
    <div class="flex justify-content-end gap-2 dialogBtnGroup">
      <app-button buttonText="common.cancel" (click)="closeDialog()"></app-button>
      <app-button
        buttonText="common.save"
        [disabled]="!form.valid || requestStarted()"
        (click)="save()"
        [loading]="requestStarted()"
      ></app-button>
    </div>
  </div>
}
